import React, { useEffect, useState } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  TextField,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";

const MultipleSelect = ({
  options,
  setState,
  state,
  field,
  isMultiple,
  haveOtherTextField,
}) => {
  const [otherText, setOtherText] = useState("");
  const haveOther = state[field]?.some((item) => item.id === "Otro");
  useEffect(() => {
    const otherField = state[field]?.find((item) => item.id === "Otro");
    if (otherField) {
      setOtherText(otherField.text);
    }
  }, []);

  const handleSelect = ({ field, value, setState, isMultiple }) => {
    setState((prevState) => {
      const currentArray = prevState[field] || [];
      const index = currentArray.findIndex((item) => item.id === value.id);

      if (!isMultiple) {
        return {
          ...prevState,
          [field]: [value],
        };
      }

      if (index > -1) {
        return {
          ...prevState,
          [field]: currentArray.filter((item) => item.id !== value.id),
        };
      } else {
        return {
          ...prevState,
          [field]: [...currentArray, value],
        };
      }
    });
  };

  const handleOtherTextChange = (event) => {
    const value = event.target.value;
    setOtherText(value);
    setState((prevState) => {
      const updatedArray = prevState[field].map((item) =>
        item.id === "Otro" ? { ...item, value: value } : item
      );

      return {
        ...prevState,
        [field]: updatedArray,
      };
    });
  };

  function MyCard({ title, id, handleSelect, index }) {
    const isIncluded = state[field]?.some((item) => item.id === id);

    return (
      <Card
        sx={{
          border: isIncluded ? "2px solid #00BBEE" : "",
          marginBottom: "10px",
          backgroundColor: "#EBF5F8",
          "&:hover": {
            backgroundColor: "#CCECF5",
          },
        }}
        elevation={0}
      >
        <CardActionArea onClick={handleSelect}>
          <CardContent sx={{ position: "relative" }}>
            {isIncluded && (
              <Box sx={{ position: "absolute", top: "5px", right: "5px" }}>
                <DoneIcon sx={{ fill: "#00BBEE" }} />
              </Box>
            )}
            <Typography sx={{ color: "#0B71C3" }}>
              {index + 1}. {title}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    );
  }

  return (
    <div>
      {Boolean(options?.length > 0) &&
        options.map((item, index) => (
          <MyCard
            index={index}
            key={item.id}
            title={item.label}
            id={item.id}
            handleSelect={() =>
              handleSelect({ field, value: item, setState, isMultiple })
            }
          />
        ))}
      {haveOtherTextField && haveOther && (
        <>
          <Typography sx={{ color: "rgba(0, 0, 0, 0.87)" }}>
            Por favor, especifique
          </Typography>
          <TextField
            value={otherText}
            sx={{
              "& .MuiInput-underline:before": {
                borderBottomColor: "#0B71C3", // Color antes de enfocar
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#00BBEE", // Color después de enfocar
              },
              "& .MuiInput-underline:hover:before": {
                borderBottomColor: "#0B71C3", // Color al pasar el mouse antes de enfocar
              },
              "& .MuiInput-input": {
                color: "#0B71C3", // Color del texto de escritura
              },
            }}
            onChange={handleOtherTextChange}
            fullWidth
            variant="standard"
          />
        </>
      )}
    </div>
  );
};

export default MultipleSelect;
